// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"0dddb64a","94":"010bbbfb","172":"3aba7e9e","314":"e7b6811b","553":"78356eaa","629":"2add2774","684":"c03c1b89","718":"b47d4b53","773":"fa9f2940","917":"33935177","957":"d385574a"}[chunkId] + ".chunk.js";
};